<div
  mdbModal
  #builderModal="mdbModal"
  class="modal fade overflow-y-auto"
  tabindex="-1"
  role="dialog"
  aria-hidden="true"
  [config]="{ ignoreBackdropClick: true }"
  (closed)="onClosed($event)"
>
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content" *ngIf="builderModal.isShown">
      <div class="modal-header border-disabled">
        <button type="button" class="close pull-right align-middle" aria-label="Close" (click)="builderModal.hide()">
          <span aria-hidden="true">×</span>
        </button>
        <h3 class="modal-title w-100" style="border-bottom: 1px solid #cccccc">Buy Together &amp; Save</h3>
      </div>
      <div *ngIf="IsWaiting">
        <div class="backdrop">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div class="modal-body d-flex flex-column" style="overflow-y: hidden">
        <ng-container *ngIf="anchor$ | async as anchor">
          <div class="row m-0 mb-3 border-bottom">
            <div class="col-md-6 col-sm-6 col-xs-12">
              <div class="row">
                <div class="col-md-6 col-sm-12 col-xs-3">
                  <img alt="{{ anchor.item.Description }}" height="250" src="{{ anchor.item.ImageUrl }}" width="250" />
                </div>

                <div class="col-md-6 col-sm-12">
                  <p class="top20">
                    <span data-testid="product-bundle-anchor-title">
                      {{ anchor.item.Manufacturer }} {{ anchor.item.Description }}
                      <br />
                      <strong data-testid="product-bundle-anchor-selling-price">{{ anchor.item.SellingPrice | currency }}</strong>
                    </span>
                    <input data-testid="product-bundle-anchor-qty"
                      type="number"
                      [(ngModel)]="anchor.item.RequestedQuantity"
                      (change)="addToBundle($event, anchor.item)"
                      class="form-control"
                      style="width: 65px"
                      min="1"
                    />
                  </p>
                </div>
              </div>
            </div>
            <ng-container *ngIf="bundle$ | async as bundle">
              <div class="col-md-6 col-sm-6 col-xs-12" style="background-color: #ffffff">
                <h4 class="top10"><strong>Your Selected Items</strong></h4>

                <hr />
                <ul>
                  <li *ngFor="let line of bundle.lines">
                    <div class="d-flex" data-testid="product-bundle-items">
                      <span class="flex-fill" [class.font-weight-bold]="line.item.HasUnsavedChanges">
                        {{ line.quantity }} x {{ line.item.Manufacturer }} {{ line.item.Description }}
                      </span>
                      <button
                          [attr.data-testid]="'product-bundle-item-remove-' + line.item.Webcode"
                        *ngIf="line.item.Webcode != anchor.item.Webcode"
                        type="button"
                        flat="true"
                        (click)="removeLine(line)"
                        class="p-0 hover-primary m-0 btn btn-flat"
                        style="align-self: flex-start"
                      >
                        <mdb-icon fas icon="trash" style="line-height: inherit"></mdb-icon>
                      </button>
                    </div>
                  </li>
                </ul>
                <hr />

                <div class="row">
                  <div class="col-md-6 col-xs-7">
                    <span>
                      <span style="color: #27ae60"
                        ><strong>Total Savings: <span data-testid="product-bundle-total-savings">
                          {{ bundleSavings | currency }}
                      </span></strong></span
                      > </span
                    ><br />

                      Items Total: <span data-testid="product-bundle-total-price">{{ bundle.price | currency }}</span>
                  </div>

                  <ng-container *ngIf="{ result: modified$ | async } as modified">
                    <div class="col-md-6 col-xs-5">
                      <a
                          data-testid="product-bundle-update-cart"
                        class="btn mdkit-button btn-block btn-raised bmd-ripple {{ this.gtagClass}}"
                        [class.btn-success]="modified.result"
                        [class.btn-update]="!modified.result"
                        href="#"
                        (click)="addToCart($event)"
                        >Update Cart</a
                      >
                    </div>
                  </ng-container>
                </div>
              </div>
            </ng-container>
          </div>
        </ng-container>

        <div class="row overflow-hidden" style="flex: 1">
          <div class="col-md-3 overflow-auto" style="border-right: 1px solid #cccccc">
            <ul class="list-unstyled">
              <li *ngFor="let cat of categories$ | async">
                <a
                  class="icons-sm p-2 category"
                  [class.category-active]="cat.id == (currentCategory$ | async).id"
                  (click)="categoryClick($event, cat)"
                  ><mdb-icon fas icon="angle-right"></mdb-icon><span class="pl-1"> {{ cat.name }}</span></a
                >
              </li>
            </ul>
          </div>
          <div class="col overflow-auto h-100">
            <div *ngIf="(currentCategory$ | async).note as note" class="alert alert-info">
              <mdb-icon fas icon="info" size="2x" class="mr-1" style="vertical-align: middle"></mdb-icon>
              {{ note }}
            </div>
            <div class="p-0 pt-2 pb-2 row border-bottom m-auto" *ngFor="let item of filteredBundleItems$ | async">
              <div class="col-md-2 col-sm-2 col-xs-3 padding-bottom">
                <img
                  alt="{{ 'item' + item.Webcode }}"
                  class="imagehover lazyloaded img-fluid"
                  src="{{ item.ImageUrl }}"
                />
              </div>

              <div class="col padding-bottom">
                <h6>{{ item.Manufacturer }} {{ item.Description }}</h6>

                Web Availability: <i class="fa fa-check text-success" *ngIf="item.StockingStatus === 'In Stock'"></i>
                {{ item.StockingStatus }}
                <p>
                  <small>Webcode: {{ item.Webcode }} &bull; Mfr: {{ item.VendorItemNo }}</small>
                </p>
              </div>

              <div class="col-md-6 col-sm-6 col-xs row row-col-md-1">
                <div class="col-lg-8 col-md padding-bottom row pr-0">
                  <div class="col">
                    <div class="row">
                      <div class="col col-xs-8">Price:</div>
                      <div class="col-auto">{{ item.SellingPrice | currency }}</div>
                    </div>
                    <div class="row" *ngIf="!item.IsAnchor">
                      <div class="col col-xs-8"><strong>Bundle Savings:</strong></div>
                      <div class="col-auto">
                        <strong>{{ (item.IsFree ? item.SellingPrice : item.BundledDiscount) | currency }}</strong>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg padding-bottom">
                  <div class="top10">
                    <input
                        [attr.data-testid]="'product-bundle-item-update-' + item.Webcode"
                      *ngIf="item.IsInCart"
                      type="number"
                      [(ngModel)]="item.RequestedQuantity"
                      (change)="addToBundle($event, item)"
                      class="form-control"
                      style="width: 65px"
                      min="1"
                    />
                    <a
                        [attr.data-testid]="'product-bundle-item-add-' + item.Webcode"
                      *ngIf="!item.IsInCart"
                      class="btn btn-sm btn-block btn-primary bmd-ripple"
                      href="#"
                      (click)="addToBundle($event, item)"
                      >Select Item</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
